<template>
  <div class="account-button-stripe">
    <ButtonBase
      theme="secondary"
      stroke="n"
      class="button"
      :disabled="error"
      rounded
      size="small"
      :to="stripeUrl"
    >
      Gérer mon abonnement
    </ButtonBase>
    <p v-if="error" class="stripe-error">
      Système momentanément indisponible.
      <button type="button" class="refresh" aria-label="Rafraichir">
        <icon name="refresh" size="1.9rem" @click="fetch" />
      </button>
    </p>
  </div>
</template>
<script setup lang="ts">
const stripeUrl = ref<string>();
const error = ref();
onMounted(async () => {
  fetch();
});
const fetch = async () => {
  error.value = null;
  const request = await useApiFetch(URI.StripeManage);
  stripeUrl.value = request.result?.redirect;
  error.value = request.error;
};
</script>
<style lang="scss" scoped>
.account-button-stripe {
  display: flex;
  flex-direction: column;
  align-items: center;

  @include above('xl') {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .button {
    width: fit-content;
    margin-top: 1rem;
  }
  .stripe-error {
    display: flex;
    align-self: center;
    place-items: center;
    color: var(--color_error);
    font-size: 1.4rem;
  }
  .refresh {
    transition: transform 0.7s ease-in-out;
    cursor: pointer;
    &:hover,
    &:focus {
      transform: rotate(360deg);
    }
  }
}
</style>
